import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Analytics } from 'packages';
import CategoryListView from './category-list-view';
import './category-list.scss';
import categoryActions from 'state/actions/categories';

class CategoryList extends Component {
    static propTypes = {
        categoryList: PropTypes.arrayOf(PropTypes.object),
        dispatch: PropTypes.func.isRequired
    };
    static displayName = 'CategoryList';

    constructor(props) {
        super(props);
        this.state = {
            filter: '',
            filteredCategories: null
        };
    }

    handleFilterChange = event => {
        this.filterCategories(event.target.value.trim());
    };

    handleFilterBlur = event => {
        const {
            target: { value }
        } = event;
        if (value && value.length > 0) {
            Analytics.trackEvent({
                category: 'Category browse',
                action: 'SearchCategories',
                label: 'Search: ' + value
            });
        }
    };

    handleFilterKey = event => {
        const { key, target } = event;
        switch (key) {
            case 'Escape':
                this.filterCategories('');
                break;
            case 'Enter':
                target.blur();
                break;
        }
    };

    filterCategories = filter => {
        const { categoryList } = this.props;
        let filteredCategories = categoryList.slice();
        if (filter.length > 0) {
            filteredCategories = filteredCategories
                .map(category => {
                    const nodes = category.categoryNodes
                        .slice()
                        .filter(node =>
                            node.title
                                .toLowerCase()
                                .includes(filter.toLowerCase())
                        );
                    return {
                        ...category,
                        open: nodes.length > 0,
                        nodes
                    };
                })
                .filter(category => category.nodes.length > 0);
        }
        this.setState({
            filter,
            filteredCategories
        });
    };

    scrollTo = event => {
        const scrollTarget = event.currentTarget.dataset.scrollTo;
        const scrollToElement = document.body.querySelector(
            `[data-scroll-target="${scrollTarget}"]`
        );
        if (scrollToElement) {
            event.preventDefault();
            let { top } = scrollToElement.getBoundingClientRect();
            top = Math.max(0, top - 50);
            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        }
    };

    handleScroll = () => {
        if (this.backToTopButton) {
            this.backToTopButton.classList.toggle(
                'd-none',
                window.scrollY < 500
            );
        }
    };

    toggleCategory = toggle => {
        const { categoryList } = this.props;
        const toggleIndex = categoryList.findIndex(
            category => category.title === toggle.title
        );
        categoryList[toggleIndex] = {
            ...categoryList[toggleIndex],
            open: !categoryList[toggleIndex].open
        };
        this.filterCategories(this.state.filter);
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(categoryActions.fetchCategoryList());
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        if (this.props.categoryList.length !== prevProps.categoryList.length) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ filteredCategories: this.props.categoryList });
        }
    }

    render() {
        const { filter, filteredCategories } = this.state;
        return (
            filteredCategories && (
                <CategoryListView
                    filter={filter}
                    filteredCategories={filteredCategories}
                    handleFilterKey={this.handleFilterKey}
                    handleFilterChange={this.handleFilterChange}
                    handleFilterBlur={this.handleFilterBlur}
                    scrollTo={this.scrollTo}
                    toggleCategory={this.toggleCategory}
                    getBackToTopButtonRef={el => (this.backToTopButton = el)}
                />
            )
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const result = {
        categoryList: state.categories.list.map(category => {
            return {
                ...category,
                open: false
            };
        }),
        ...ownProps
    };
    return result;
};

export default connect(mapStateToProps)(CategoryList);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/category-list/category-list.jsx